import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankIdIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 118,
	height: 18,
	viewBox: "0 0 118 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.78591 2.51163H1.76265C1.09288 2.51163 0.506836 1.92558 0.506836 1.25581C0.506836 0.586047 1.09288 0 1.76265 0H6.78591C7.45567 0 8.04172 0.586047 8.04172 1.25581C8.04172 1.92558 7.45567 2.51163 6.78591 2.51163Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.78609 12.558H1.76283C1.09307 12.558 0.507019 11.972 0.507019 11.3022C0.507019 10.6324 1.09307 10.0464 1.76283 10.0464H6.78609C7.45586 10.0464 8.0419 10.6324 8.0419 11.3022C8.0419 11.972 7.45586 12.558 6.78609 12.558Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.78609 17.5813H1.76283C1.09307 17.5813 0.507019 16.9953 0.507019 16.3255C0.507019 15.6557 1.09307 15.0697 1.76283 15.0697H6.78609C7.45586 15.0697 8.0419 15.6557 8.0419 16.3255C8.0419 16.9953 7.45586 17.5813 6.78609 17.5813Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8329 7.53507H11.8096C11.1399 7.53507 10.5538 6.94902 10.5538 6.27925C10.5538 5.60948 11.1399 5.02344 11.8096 5.02344H16.8329C17.5027 5.02344 18.0887 5.60948 18.0887 6.27925C18.0887 6.94902 17.5027 7.53507 16.8329 7.53507Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8329 12.558H11.8096C11.1399 12.558 10.5538 11.972 10.5538 11.3022C10.5538 10.6324 11.1399 10.0464 11.8096 10.0464H16.8329C17.5027 10.0464 18.0887 10.6324 18.0887 11.3022C18.0887 11.972 17.5027 12.558 16.8329 12.558Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8787 2.51163H21.8555C21.1857 2.51163 20.5997 1.92558 20.5997 1.25581C20.5997 0.586047 21.1857 0 21.8555 0H26.8787C27.5485 0 28.1346 0.586047 28.1346 1.25581C28.1346 1.92558 27.5485 2.51163 26.8787 2.51163Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8787 7.53507H21.8555C21.1857 7.53507 20.5997 6.94902 20.5997 6.27925C20.5997 5.60948 21.1857 5.02344 21.8555 5.02344H26.8787C27.5485 5.02344 28.1346 5.60948 28.1346 6.27925C28.1346 6.94902 27.5485 7.53507 26.8787 7.53507Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8787 17.5813H21.8555C21.1857 17.5813 20.5997 16.9953 20.5997 16.3255C20.5997 15.6557 21.1857 15.0697 21.8555 15.0697H26.8787C27.5485 15.0697 28.1346 15.6557 28.1346 16.3255C28.1346 16.9953 27.5485 17.5813 26.8787 17.5813Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.8513 10.9674C38.8513 13.6465 40.3582 15.0698 42.1164 15.0698C43.7071 15.0698 45.4652 13.7302 45.4652 10.9674C45.4652 8.20465 43.7908 6.94884 42.2001 6.94884C40.442 6.94884 38.8513 8.20465 38.8513 10.9674ZM38.8513 0V6.53023C39.6047 5.35814 40.9443 4.18605 43.2047 4.18605C45.7164 4.18605 48.7303 6.27907 48.7303 10.8837C48.7303 15.6558 45.8838 18 42.9536 18C41.2792 18 39.8559 17.2465 38.935 15.7395V17.5814H35.6699V0H38.8513Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.5024 11.0511C53.5024 13.8139 55.1768 15.0697 56.7675 15.0697C58.5256 15.0697 60.0326 13.8976 60.0326 11.0511C60.0326 8.28834 58.5256 6.94881 56.7675 6.94881C55.2605 6.94881 53.5024 8.20462 53.5024 11.0511ZM50.321 10.8837C50.321 6.36276 53.2512 4.10229 56.1814 4.10229C57.7721 4.10229 59.1117 4.68834 60.1163 6.1116V4.43718H63.2977V17.5814H60.1163V15.7395C59.1954 16.9953 57.8559 17.9162 55.7628 17.9162C53.2512 17.9162 50.321 15.7395 50.321 10.8837Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.5767 10.13V17.5811H66.3953V4.52067H69.5767V6.44626C70.4977 4.77184 72.1721 4.18579 73.5953 4.18579C75.8558 4.18579 78.0325 5.35788 78.0325 8.87416V17.5811H74.8511V10.0463C74.8511 7.86951 73.7628 7.0323 72.3395 7.0323C70.7488 7.11602 69.5767 8.03695 69.5767 10.13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.0458 0V17.5814H84.2272V14.4L85.9853 12.2233L89.5853 17.5814H93.1016L87.9109 9.96279L92.4318 4.52093H88.8318L84.2272 10.5488V0H81.0458Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M99.4641 0.586182H96.199V17.5815H99.4641V0.586182Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.925 0.586182H102.729V17.5815H108.925C113.529 17.5815 117.38 14.8187 117.38 9.042C117.38 3.34897 113.529 0.586182 108.925 0.586182ZM108.925 14.5676H105.994V3.60014H108.925C111.604 3.60014 113.864 5.35827 113.864 9.12572C113.864 12.8094 111.604 14.5676 108.925 14.5676Z",
			fill: "currentColor"
		})
	]
});
export default SvgBankIdIcon;
